import { PhoneRegion } from '@/helpers/phoneHelper';

export const useDefaultPhoneRegion = () => {
  return PhoneRegion.UnitedKingdom;
};
